"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVidForUserInfo = exports.findVidForUserInfo = exports.getVid = exports.setVid = exports.start = void 0;
var uuid_1 = require("uuid");
var api_1 = __importStar(require("@aws-amplify/api"));
var queries = __importStar(require("./graphql/queries"));
var mutations = __importStar(require("./graphql/mutations"));
var JAZEL_VID_KEY = 'jzl_visitor_id';
function start() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    });
}
exports.start = start;
function setVid(vid) {
    if (vid != null) {
        localStorage.setItem(JAZEL_VID_KEY, vid);
        console.log("Saved VID", vid);
    }
    else {
        localStorage.removeItem(JAZEL_VID_KEY);
        console.log("Cleared VID");
    }
}
exports.setVid = setVid;
function getVid() {
    // vid is "visitor id" and is in local storage.
    // we use this to key our user when going to the graphql server
    var _vid = window.localStorage.getItem(JAZEL_VID_KEY);
    if (_vid != null) {
        console.log("Using VID", _vid);
    }
    else {
        // generate a vid, which will be a uuid
        _vid = uuid_1.v4();
        // save it back to local storage
        setVid(_vid);
        console.log("Created VID", _vid);
    }
    return _vid;
}
exports.getVid = getVid;
function findVidForUserInfo(groupId, loginId, provider) {
    return __awaiter(this, void 0, void 0, function () {
        var input, result, findLoginIdentity, item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    input = {
                        groupId: groupId,
                        loginIdProvider: {
                            eq: {
                                loginId: loginId,
                                provider: provider,
                            },
                        },
                    };
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(queries.findLoginIdentity, input))];
                case 1:
                    result = _a.sent();
                    findLoginIdentity = result.data.findLoginIdentity;
                    if (findLoginIdentity == null || findLoginIdentity.items == null) {
                        return [2 /*return*/, null];
                    }
                    item = findLoginIdentity.items.find(function (item) { return item != null; });
                    if (item == null || item.visitorProfile == null) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, item.visitorProfile.id];
            }
        });
    });
}
exports.findVidForUserInfo = findVidForUserInfo;
function setVidForUserInfo(groupId, loginId, provider, vid) {
    return __awaiter(this, void 0, void 0, function () {
        var input;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    input = {
                        input: {
                            groupId: groupId,
                            loginId: loginId,
                            provider: provider,
                            loginIdentityVisitorProfileId: vid,
                        },
                    };
                    return [4 /*yield*/, api_1.default.graphql(api_1.graphqlOperation(mutations.createLoginIdentity, input))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.setVidForUserInfo = setVidForUserInfo;
//# sourceMappingURL=vid.js.map